import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticleGuide from "../pages/mulebuy-spreadsheet-guide/page";
import ArticleTools from "../pages/articles/mulebuy-spreadsheet-tools";
import ArticleComparison from "../pages/articles/mulebuy-spreadsheet-comparison";
import ArticleTutorial from "../pages/articles/mulebuy-spreadsheet-tutorial";
import ArticleSafety from "../pages/articles/mulebuy-spreadsheet-safety";
import ArticleAlternatives from "../pages/articles/mulebuy-spreadsheet-alternatives";
import ArticleAutomation from "../pages/articles/mulebuy-spreadsheet-automation";
import ArticleErrors from "../pages/articles/mulebuy-spreadsheet-errors";
import ArticleBusiness from "../pages/articles/mulebuy-spreadsheet-business";
import ArticleTrending from "../pages/articles/mulebuy-spreadsheet-trending";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/mulebuy-spreadsheet-guide",
    element: <ArticleGuide />,
  },
  {
    path: "/mulebuy-spreadsheet-tools",
    element: <ArticleTools />,
  },
  {
    path: "/mulebuy-spreadsheet-comparison",
    element: <ArticleComparison />,
  },
  {
    path: "/mulebuy-spreadsheet-tutorial",
    element: <ArticleTutorial />,
  },
  {
    path: "/mulebuy-spreadsheet-safety",
    element: <ArticleSafety />,
  },
  {
    path: "/mulebuy-spreadsheet-alternatives",
    element: <ArticleAlternatives />,
  },
  {
    path: "/mulebuy-spreadsheet-automation",
    element: <ArticleAutomation />,
  },
  {
    path: "/mulebuy-spreadsheet-errors",
    element: <ArticleErrors />,
  },
  {
    path: "/mulebuy-spreadsheet-business",
    element: <ArticleBusiness />,
  },
  {
    path: "/mulebuy-spreadsheet-trending",
    element: <ArticleTrending />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;